import { addSuppressedError } from '@shared/utils/logger';

export type RenditionSize = 'avatar' | 'tiny' | 'small' | 'medium' | 'large' | 'xlarge' | 'full';

export const addRendition = <T>({ url, renditionSize, isProduct }: { url: T; renditionSize?: RenditionSize; isProduct?: boolean }): T | string => {
  if (typeof url === 'string' && url.length) {
    try {
      const photoRequestUrl = new URL(url);
      if (renditionSize) {
        photoRequestUrl.searchParams.set('rendition', renditionSize);
      }
      if (isProduct) {
        photoRequestUrl.searchParams.set('product', 'true');
      }
      return photoRequestUrl.toString();
    } catch (err) {
      addSuppressedError(err, { context: 'addRendition', url });
    }
  }
  return url;
};

/**
 * Inverse of `addRendition`: strips the `rendition` query param so the original,
 * full-resolution asset is fetched. Use this for downloads — display surfaces should
 * keep their rendition for performance, but downloads must always be the uncompressed original.
 * Other params (e.g. `product`) are preserved. Returns the input unchanged if it is not a parseable URL.
 */
export const removeRendition = (url: string): string => {
  if (typeof url === 'string' && url.length) {
    try {
      const photoRequestUrl = new URL(url);
      photoRequestUrl.searchParams.delete('rendition');
      return photoRequestUrl.toString();
    } catch (err) {
      addSuppressedError(err, { context: 'removeRendition', url });
    }
  }
  return url;
};
